export const removeEmbeddedSize = (svg: string) => {
  return svg.replace(/(height|width)=['"].*?['"]/gi, '');
};
